import { useQuery } from '@tanstack/react-query';

import { getDocumentSearchFilters } from '@entities/document/api/document';

/**
 * 문서 검색 필터 옵션 조회 (팀/양식 목록)
 * - 관리자 문서관리 페이지에서 검색 필터 셀렉트 옵션용
 * @returns {UseQueryResult<{ teams: Array, docTypes: Array }>}
 */
function useDocumentSearchFiltersQuery() {
  return useQuery({
    queryKey: ['documentSearchFilters'],
    queryFn: getDocumentSearchFilters,
    select: (data) => ({
      teams: data?.resultData?.teamNameList ?? [],
      docTypes: data?.resultData?.docTypeList ?? [],
    }),
  });
}

export default useDocumentSearchFiltersQuery;
